import { QuickActionButton } from '@components/common/QuickActionButton';
import { theme } from 'aimo-ui';
import { useTranslation } from 'react-i18next';
import { LatLng } from 'types/MapTypes';
import { openDirections } from 'utils/mapUtils';

type QuickActionDirectionProps = {
  name?: string | null;
  markerCoordinate?: LatLng | null;
  showIconLabel: boolean;
  alignEnd?: boolean;
};

const QuickActionDirection = ({
  name,
  markerCoordinate,
  showIconLabel,
  alignEnd,
}: QuickActionDirectionProps) => {
  const { t } = useTranslation();
  const coloring = markerCoordinate
    ? theme.colors.boost.green
    : theme.colors.gray100;
  return (
    <QuickActionButton
      testID="parkzone-quickaction-directions"
      onPress={() => openDirections(name, markerCoordinate)}
      disabled={!markerCoordinate}
      iconName="Directions-Outlined"
      coloring={coloring}
      iconLabel={showIconLabel ? t('quickAction.directions') : undefined}
      alignEnd={alignEnd}
    />
  );
};

export default QuickActionDirection;
